// extracted by mini-css-extract-plugin
module.exports = {"title":"PreferencesContainer_title__3ggmX"};